export default __webpack_public_path__ + "static/media/laptop5.2a70b805.jpeg";